export type CountryOption = { value: string; label: string }

const PINNED: CountryOption[] = [
  { value: 'USA', label: 'United States' },
  { value: 'BRA', label: 'Brazil' },
  { value: 'MEX', label: 'Mexico' },
]

const PINNED_VALUES = new Set(PINNED.map((c) => c.value))

const REST: CountryOption[] = [
  { value: 'ARG', label: 'Argentina' },
  { value: 'AUS', label: 'Australia' },
  { value: 'AUT', label: 'Austria' },
  { value: 'BEL', label: 'Belgium' },
  { value: 'BOL', label: 'Bolivia' },
  { value: 'CAN', label: 'Canada' },
  { value: 'CHL', label: 'Chile' },
  { value: 'CHN', label: 'China' },
  { value: 'COL', label: 'Colombia' },
  { value: 'CRI', label: 'Costa Rica' },
  { value: 'DEU', label: 'Germany' },
  { value: 'DNK', label: 'Denmark' },
  { value: 'ECU', label: 'Ecuador' },
  { value: 'ESP', label: 'Spain' },
  { value: 'FIN', label: 'Finland' },
  { value: 'FRA', label: 'France' },
  { value: 'GBR', label: 'United Kingdom' },
  { value: 'GTM', label: 'Guatemala' },
  { value: 'HND', label: 'Honduras' },
  { value: 'IND', label: 'India' },
  { value: 'IRL', label: 'Ireland' },
  { value: 'ITA', label: 'Italy' },
  { value: 'JPN', label: 'Japan' },
  { value: 'KOR', label: 'South Korea' },
  { value: 'LUX', label: 'Luxembourg' },
  { value: 'NIC', label: 'Nicaragua' },
  { value: 'NLD', label: 'Netherlands' },
  { value: 'NOR', label: 'Norway' },
  { value: 'NZL', label: 'New Zealand' },
  { value: 'PAN', label: 'Panama' },
  { value: 'PER', label: 'Peru' },
  { value: 'PRT', label: 'Portugal' },
  { value: 'PRY', label: 'Paraguay' },
  { value: 'RUS', label: 'Russia' },
  { value: 'SAU', label: 'Saudi Arabia' },
  { value: 'SLV', label: 'El Salvador' },
  { value: 'SWE', label: 'Sweden' },
  { value: 'TUR', label: 'Turkey' },
  { value: 'URY', label: 'Uruguay' },
  { value: 'VEN', label: 'Venezuela' },
  { value: 'ZAF', label: 'South Africa' },
].filter((c) => !PINNED_VALUES.has(c.value))
  .sort((a, b) => a.label.localeCompare(b.label))

export const COUNTRY_OPTIONS: CountryOption[] = [...PINNED, ...REST]

const ALPHA3_TO_ALPHA2: Record<string, string> = {
  USA: 'US', BRA: 'BR', MEX: 'MX', ARG: 'AR', AUS: 'AU',
  AUT: 'AT', BEL: 'BE', BOL: 'BO', CAN: 'CA', CHL: 'CL',
  CHN: 'CN', COL: 'CO', CRI: 'CR', DEU: 'DE', DNK: 'DK',
  ECU: 'EC', ESP: 'ES', FIN: 'FI', FRA: 'FR', GBR: 'GB',
  GTM: 'GT', HND: 'HN', IND: 'IN', IRL: 'IE', ITA: 'IT',
  JPN: 'JP', KOR: 'KR', LUX: 'LU', NIC: 'NI', NLD: 'NL',
  NOR: 'NO', NZL: 'NZ', PAN: 'PA', PER: 'PE', PRT: 'PT',
  PRY: 'PY', RUS: 'RU', SAU: 'SA', SLV: 'SV', SWE: 'SE',
  TUR: 'TR', URY: 'UY', VEN: 'VE', ZAF: 'ZA',
}

export function flagEmoji(alpha3: string): string {
  const alpha2 = ALPHA3_TO_ALPHA2[alpha3]
  if (!alpha2) return ''
  return String.fromCodePoint(
    0x1f1e6 + alpha2.charCodeAt(0) - 65,
    0x1f1e6 + alpha2.charCodeAt(1) - 65,
  )
}

export function countryLabel(alpha3: string): string {
  const flag = flagEmoji(alpha3)
  const found = COUNTRY_OPTIONS.find((c) => c.value === alpha3)
  const name = found?.label ?? alpha3
  return flag ? `${flag} ${name}` : name
}
